<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { formatBaseCurrencyString, isMobile, isTablet, loggedIn, refreshSelfInfo, refreshVipLevels, refreshVipState, stateNextLevelUpCashback, stateUserLevelNum, stateUsername, stateUserRank, stateUserSublevelNum, stateVipProgress } from "@infinitro/global";
import { Icon } from "@infinitro/rank-badges";
import { Text } from "@infinitro/text";
import ProgressBar from "../progress-bar.svelte";
let didRefreshOnLogin = false;
export let rankIconSizeMobile = 100;
export let rankIconSizeDesktop = 150;
$: isPhone = $isMobile && !$isTablet;
$: if ($loggedIn && !didRefreshOnLogin) {
	didRefreshOnLogin = true;
	refreshVipLevels();
	refreshSelfInfo();
	refreshVipState();
}
$: if (!$loggedIn) {
	didRefreshOnLogin = false;
}
</script>

<div class="big-card-player">
	<img
		src={cfgToThemeCdnPath(`/top-section/big-card-player.png`)}
		alt={$t(Verbiage.hero_banner_alt, 'alts')}
		class="big-card-bg"
	/>
	<img
		src={cfgToThemeCdnPath(`/top-section/ranks-backgrounds/${$stateUserLevelNum ?? 1}.png`)}
		alt={$stateUserRank}
		class="big-card-rank-bg"
	/>
	<div class="big-card-content-container">
		<div class="big-card-content">
			<div class="username-rank-container">
				{#key `${$isMobile}-${$isTablet}`}
					<Text
						type="subtitle"
						subtitleWeight="bold"
						subtitleSize={isPhone ? 'small' : 'large'}
						customStyle="color: var(--color-highlight-5); font-size: {isPhone ? '17px' : '24px'};"
						>{$stateUsername ?? ''}</Text
					>
				{/key}
			</div>
			<div>
				{#key `${$isMobile}-${$isTablet}`}
					<div class="row-container">
						<Text
							bodySize={isPhone ? 'xsmall' : 'large'}
							bodyWeight="semibold"
							customStyle="font-size: {isPhone ? '12px' : ''};"
							>{$t(Verbiage.rewards_progress)}</Text
						>
						<Text
							bodySize={isPhone ? 'xsmall' : 'large'}
							bodyWeight="semibold"
							customStyle="font-size: {isPhone ? '12px' : ''};"
							><span class="with-highlight">{`${$stateVipProgress}%`}</span></Text
						>
					</div>
				{/key}
				<ProgressBar progress={$stateVipProgress} height={$isMobile ? '4px' : '6px'} />
				{#key `${$isMobile}-${$isTablet}`}
					<div class="row-container">
						<Text
							bodySize={isPhone ? 'xsmall' : 'large'}
							bodyWeight="semibold"
							customStyle="font-size: {isPhone ? '12px' : ''};"
							>{$t(Verbiage.upcoming_rewards)}</Text
						>
						<Text
							bodySize={isPhone ? 'xsmall' : 'large'}
							bodyWeight="semibold"
							customStyle="font-size: {isPhone ? '12px' : ''};"
							><span class="with-highlight"
								>{`${$stateNextLevelUpCashback ? formatBaseCurrencyString($stateNextLevelUpCashback) : ''}`}</span
							></Text
						>
					</div>
				{/key}
			</div>
			<!-- Sublevel steps UI was here; rank labels should use stateUserVipRankDisplay / stateUserNextRankDisplay from API if re-enabled. -->
		</div>
		<div class="big-card-rank-container">
			{#key $isMobile}
				<Icon
					rank={$stateUserLevelNum}
					level={$stateUserSublevelNum}
					size={isPhone ? rankIconSizeMobile : rankIconSizeDesktop}
					sizeAsPercent={$isMobile}
				/>
			{/key}
		</div>
	</div>
</div>

<style>
	.big-card-player {
		position: relative;
		display: flex;
		height: auto;
		min-height: 150px;
		width: 100%;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border-radius: 12px;
		box-shadow: 0px 0px 5px 0px rgba(var(--color-primary-500-rgb) / 0.5);
		aspect-ratio: 60 / 25;
}

	.big-card-player::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: 12px;
		padding: 1px;
		background: linear-gradient(
			180deg,
			rgba(var(--color-primary-500-rgb) / 0.9) 0%,
			rgba(255, 255, 255, 0) 100%
		);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 1;
	}

	.big-card-bg {
		position: absolute;
		top: 0px;
		bottom: 0px;
		left: 50%;
		z-index: 0;
		height: 100%;
		width: 100%;
		max-width: 100%;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		-o-object-fit: cover;
		   object-fit: cover;
}

	.big-card-content {
		position: relative;
		display: flex;
		height: 87px;
		min-height: 87px;
		width: 60%;
		flex-direction: column;
		justify-content: space-around;
		z-index: 2;
}

	.row-container {
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
}

	.with-highlight {
		color: var(--color-highlight-5);
	}

	.text-off {
		color: var(--color-background-900);
}

	.steps {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-around;
		gap: 0.25rem;
}

	.big-card-rank-bg {
		position: absolute;
		inset: 0px;
		left: 50%;
		z-index: 0;
		height: auto;
		width: 200%;
		max-width: none;
		--tw-translate-x: -50%;
		--tw-translate-y: -11.8%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

	.big-card-content-container {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		padding-left: 1rem;
}

	.big-card-rank-container {
		display: flex;
		height: 100%;
		width: 40%;
		align-items: center;
		justify-content: center;
}

	@media (min-width: 640px) {
		.big-card-player {
				height: 100%;
			aspect-ratio: 75 / 25;
		}

		.big-card-content {
				height: 100%;
				max-height: none;
				width: 100%;
		}

		.big-card-content-container {
				padding: 2rem;
				padding-top: 6rem;
				padding-bottom: 6rem;
				padding-right: 0px;
		}

		.row-container {
				margin-top: 1rem;
				margin-bottom: 1rem;
		}

		.big-card-rank-bg {
				width: 150%;
				--tw-translate-y: -12%;
				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		}
	}

	@media (min-width: 1024px) {
		.big-card-player {
				height: 100%;
			aspect-ratio: 60 / 25;
		}

		.big-card-content {
				height: 100%;
				max-height: none;
				width: 100%;
		}

		.big-card-content-container {
				padding: 2rem;
				padding-top: 3rem;
				padding-bottom: 3rem;
				padding-right: 0px;
		}

		.big-card-rank-bg {
				--tw-translate-y: -7%;
				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		}
	}
</style>
